'use client';

import classnames from 'classnames';

import styles from '../plugins/ToolbarPlugin.module.scss';

type ToolbarButtonProps = {
  onClick: () => void;
  disabled?: boolean;
  active?: boolean;
  ariaLabel: string;
  title?: string;
  iconClassName: string;
  className?: string;
};

export function ToolbarButton({
  onClick,
  disabled = false,
  active = false,
  ariaLabel,
  title,
  iconClassName,
  className,
}: ToolbarButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={classnames(
        styles['toolbar-item'],
        active && styles['active'],
        className,
      )}
      aria-label={ariaLabel}
      title={title ?? ariaLabel}
    >
      <i className={classnames(styles['format'], iconClassName)} />
    </button>
  );
}
